import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { metrics, categories } from '../data/metrics';
import { FiArrowLeft, FiBarChart2 } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import clsx from 'clsx';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const category = categories.find((c) => c.id === categoryId);
  const catMetrics = metrics.filter((m) => m.categoryId === categoryId);

  if (!category) return <div className="p-8 text-center text-slate-500">Category not found</div>;

  return (
    <div className="max-w-7xl mx-auto">
      <button
        onClick={() => navigate('/')}
        className="flex items-center text-slate-500 hover:text-jeruel-blue mb-6 transition-colors font-medium text-sm group"
      >
        <div className="bg-white border border-jeruel-grayblue rounded-full p-1.5 mr-2 group-hover:border-jeruel-blue">
          <SafeIcon icon={FiArrowLeft} />
        </div>
        Back to Dashboard
      </button>

      <div className={clsx("mb-8 p-8 rounded-2xl shadow-sm border flex items-start gap-6", category.bg, category.border)}>
        <div className="p-4 bg-white rounded-xl shadow-sm text-3xl">
          <SafeIcon name={category.icon} className={category.color} />
        </div>
        <div>
          <h2 className="text-3xl font-bold text-slate-900 mb-2">{category.name}</h2>
          <p className="text-slate-700 text-lg opacity-80 max-w-2xl">
            {catMetrics.length} metrics available for calculation and benchmarking
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {catMetrics.map((metric) => (
          <button
            key={metric.id}
            onClick={() => navigate(`/calculator/${metric.id}`)}
            className="block bg-white rounded-xl shadow-sm border border-jeruel-grayblue hover:border-jeruel-blue hover:ring-1 hover:ring-jeruel-blue hover:shadow-lg transition-all duration-300 p-6 group h-full flex flex-col text-left"
          >
            <div className="flex items-start justify-between mb-4">
              <SafeIcon icon={FiBarChart2} className="text-slate-300 group-hover:text-jeruel-blue transition-colors text-xl" />
            </div>
            <h3 className="font-bold text-lg text-slate-800 mb-2 group-hover:text-jeruel-blue transition-colors">
              {metric.name}
            </h3>
            <p className="text-sm text-slate-500 line-clamp-3 mb-4 flex-1">
              {metric.definition}
            </p>
            <div className="pt-4 border-t border-jeruel-soft flex items-center text-xs font-medium text-slate-400 group-hover:text-jeruel-blue">
              <span>View Calculator</span>
            </div>
          </button>
        ))}

        {catMetrics.length === 0 && (
          <div className="col-span-full text-center py-16 text-slate-400 bg-white rounded-xl border border-dashed border-jeruel-grayblue">
            No metrics found in this category yet.
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;